import { PeerGamingApiSlice } from '../PeerGamingApiSlice';
import { Story } from './types';

const storySlice = PeerGamingApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		fetchStories: builder.query<
			Story[],
			{ id?: number; resource?: string; linkId: number } | undefined
		>({
			query: (request) => ({
				url: '/Story',
				params: {
					id: request?.id,
					resource: request?.resource,
					linkId: request?.linkId
				}
			}),
			providesTags: ['Stories']
		}),

		postStory: builder.mutation<Story, Partial<Story>>({
			query: (request) => ({
				url: '/Story',
				method: 'POST',
				body: request
			}),
			invalidatesTags: ['Stories']
		}),

		addStoryImage: builder.mutation<{ url: string }, FormData>({
			query: (request) => ({
				url: '/Story/Image',
				method: 'POST',
				body: request
			})
		})
	})
});

export const {
	useFetchStoriesQuery,
	usePostStoryMutation,
	useAddStoryImageMutation
} = storySlice;
